<!-- //* 数字递增动画组件 -->
<template>
    <div class="module-container">
        <span class="module-number" ref="container">{{ max / 2 }}</span>
        <span class="module-unit" v-if="unit">{{ unit }}</span>
    </div>
</template>

<script lang="ts" setup>
import { gsap } from "gsap";

const define = defineProps({
    delay: { type: Number, default: 2 },
    max: { type: Number, required: true },
    decimals: { type: Number, default: 0 },
    unit: { type: String, default: "" },
});

const data = { score: define.max / 2 };
const container = ref<HTMLElement>();

gsap.to(data, {
    score: define.max,
    duration: define.delay,
    onUpdate: () => {
        if (!container.value) return;
        container.value.innerText = data.score.toFixed(define.decimals).toString();
    },
});
</script>

<style lang="less" scoped>
.module-conainer {
    .module-body {
        .module-unit {
            padding-left: 10px;
        }
    }
}
</style>
